export const ATTACHMENT_SOURCE = {
  EXTRACTION: 'EXTRACTION',
};
